import { useAuth } from "../context/useAuthContext";

const Footer = () => {
  const { auth } = useAuth();
  const userName = auth?.fullName;
  const lastLogin = auth?.lastLogin;

  return (
    <>
      {/* Footer */}
      <div
        className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3 py-2 bg-dark"
        style={{ fontSize: "0.78rem" }}
      >
        <div>
          <div className="d-flex align-items-center justify-content-center gap-3 mb-1">
            <div>User Name: {userName}</div>
            <div
              className="vr my-auto d-none d-md-block"
              style={{ height: 10 }}
            ></div>
            <div className="d-none d-md-block">
              Last Login:{" "}
              {lastLogin
                ? new Date(lastLogin)
                    .toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })
                    .replace(/\//g, "-")
                : "-"}
            </div>
          </div>
          <div className="text-center d-md-none mb-2">
            Last Login:{" "}
            {lastLogin
              ? new Date(lastLogin)
                  .toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  })
                  .replace(/\//g, "-")
              : "-"}
          </div>
          <div className="d-flex flex-column flex-md-row align-items-center justify-content-md-center gap-md-3">
            {/* <div>Policies: Privacy Policy & EU/GDPR Privacy Policy</div> */}
            {/* <div
              className="vr my-auto d-none d-md-block"
              style={{ height: 10 }}
            ></div> */}
            <div>
              Copyright © - {new Date().getFullYear()} Aupertz All rights
              reserved.
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
